import { ChangeDetectionStrategy, Component, inject, signal, OnInit } from '@angular/core';
import { DsgvoService } from '@mwe/services';
import { PROFILE_DSGVO_SETTINGS_ROUTE, PROFILE_ROUTE } from '@mwe/constants';
import { InfoboxComponent } from '../../infobox/infobox.component';

@Component({
  selector: 'mwe-dsgvo-disclaimer',
  templateUrl: './dsgvo-disclaimer.component.html',
  imports: [InfoboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsgvoDisclaimerComponent implements OnInit {
  private readonly dsgvoService = inject(DsgvoService);

  isCardVisible = signal(false);
  textParams = signal<{ url: string } | undefined>(undefined);

  async ngOnInit(): Promise<void> {
    try {
      const url = `/${PROFILE_ROUTE}/${PROFILE_DSGVO_SETTINGS_ROUTE}`;
      this.textParams.set({ url });

      this.isCardVisible.set(await this.dsgvoService.isDsgvoSuccessfullySet());
    } catch (_) {
      // ignore error
      this.isCardVisible.set(false);
    }
  }
}
